import { render, staticRenderFns } from "./ManageHideResponsavelNotasListView.vue?vue&type=template&id=3fb25ec0"
import script from "./ManageHideResponsavelNotasListView.vue?vue&type=script&lang=ts"
export * from "./ManageHideResponsavelNotasListView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports